import { render } from "./TicketBooking.vue?vue&type=template&id=2adf314a&scoped=true"
import script from "./TicketBooking.vue?vue&type=script&lang=js"
export * from "./TicketBooking.vue?vue&type=script&lang=js"

import "./TicketBooking.vue?vue&type=style&index=0&id=2adf314a&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adf314a"]])

export default __exports__